import createIcon from '../../createIcon';

/**
 * @component @name OfflineShare
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNiAxMC4yNlYxMS41N0wxNyA5LjMzTDE0LjYgNy4xVjguMzhDMTIuMjcgOC43IDExLjM0IDEwLjMgMTEgMTEuOUMxMS44MyAxMC43NyAxMi45MyAxMC4yNiAxNC42IDEwLjI2Wk0xNiAyM0g2QzQuOSAyMyA0IDIyLjEgNCAyMVY1SDZWMjFIMTZWMjNaTTE4IDFIMTBDOC45IDEgOCAxLjkgOCAzVjE3QzggMTguMSA4LjkgMTkgMTAgMTlIMThDMTkuMSAxOSAyMCAxOC4xIDIwIDE3VjNDMjAgMS45IDE5LjEgMSAxOCAxWk0xOCAxNkgxMFY0SDE4VjE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OfflineShare = createIcon('OfflineShare', [
  [
    'path',
    {
      d: 'M14.6 10.26V11.57L17 9.33L14.6 7.1V8.38C12.27 8.7 11.34 10.3 11 11.9C11.83 10.77 12.93 10.26 14.6 10.26ZM16 23H6C4.9 23 4 22.1 4 21V5H6V21H16V23ZM18 1H10C8.9 1 8 1.9 8 3V17C8 18.1 8.9 19 10 19H18C19.1 19 20 18.1 20 17V3C20 1.9 19.1 1 18 1ZM18 16H10V4H18V16Z',
      key: 'k63mp3',
    },
  ],
]);

export default OfflineShare;
